var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-radio flex flex-mid flex-center",class:_vm.value_ == _vm.radioData_.id?'cus-sel':'',on:{"click":function($event){_vm.value_ = _vm.radioData_.id}}},[_vm._v("\n    "+_vm._s(_vm.radioData_.name)+"\n\n\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2caf6c98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerRadio.vue
// module id = null
// module chunks = 